module.exports = __webpack_public_path__ + "static/media/loc3_img12.6c37945a.jpg";